import GenericAttributeModel from './GenericAttributeModel';

export default GenericAttributeModel;
